import AppRoot from './app/App';

export default function App() {
  return <AppRoot />;
}
